import { render, staticRenderFns } from "./OrganizQuizList.vue?vue&type=template&id=6993409b&scoped=true&"
import script from "./OrganizQuizList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizQuizList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizQuizList.vue?vue&type=style&index=0&id=6993409b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6993409b",
  null
  
)

export default component.exports